import { SET_REMEMBER, SET_TOKENS, DESTROY_TOKENS, LOGIN_MESSAGE } from './mutation-types'
import axios from 'axios'
import jwtDecode from 'jwt-decode'

const state = {
    errorMessage: null,

    token: '',
    tokenExp: 0,
    refreshToken: '',

    remember: false,

    isAdmin: false,
    cid: null
}

const getters = {
    isAuth: state => !!state.token,

    /**
     * Геттер возвращает функцию, которая скажет, пора обновить токены (true) или еще нет (false)
     * Вызывать как функцию!
     */
    itsTimeToRefreshTokens: (state, getters) => () => getters.isAuth && Date.now() > state.tokenExp,

    /**
     * Когда админ админ залогинился под какой-то компанией.
     */
    isLoggedAsAdmin: (state) => state.isAdmin && state.cid !== null
}

const mutations = {
    [SET_REMEMBER](state, remember) {
        state.remember = remember
    },

    [SET_TOKENS](state, { token, tokenExp, refreshToken }) {
        state.token = token
        state.tokenExp = tokenExp
        state.refreshToken = refreshToken

        if (state.remember) {
            localStorage.setItem('token', token)
            localStorage.setItem('tokenExp', tokenExp)
            localStorage.setItem('refreshToken', refreshToken)
        }

        const claims = jwtDecode(token)
        state.isAdmin = claims && claims.admin === true
        state.cid = claims.cid || null
    },

    [LOGIN_MESSAGE](state, message) {
        state.errorMessage = message
    },

    [DESTROY_TOKENS](state) {
        state.token = ''
        state.tokenExp = 0
        state.refreshToken = ''

        localStorage.removeItem('token')
        localStorage.removeItem('tokenExp')
        localStorage.removeItem('refreshToken')
    }
}

const actions = {
    async login({ commit, dispatch }, { username, password, remember = false }) {
        if (!username || !password) {
            return false
        }

        commit(LOGIN_MESSAGE)
        commit(SET_REMEMBER, remember)

        let data = {
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            grant_type: 'password',
            username,
            password
        }

        try {
            let response = await axios.post('oauth/token', data)

            commit(SET_TOKENS, {
                token: response.data.access_token,
                tokenExp: Date.now() + response.data.expires_in * 1000,
                refreshToken: response.data.refresh_token
            })
        } catch (error) {
            if (error.response) {
                const msg = error.response.data.error

                commit(LOGIN_MESSAGE, (msg === 'invalid_credentials' || msg === 'invalid_grant')
                    ? 'Неверный логин или пароль!'
                    : error.response.data.message
                )
            } else {
                commit(LOGIN_MESSAGE, 'Сервис временно недоступен')
            }

            return false
        }

        return true
    },

    async refreshTokens({ state, commit, dispatch }, params = { }) {
        if (!state.refreshToken) {
            return false
        }

        let data = {
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            grant_type: 'refresh_token',
            refresh_token: state.refreshToken,
            scope: '',
            ...params
        }

        try {
            let response = await axios.post('oauth/token', data)

            commit(SET_TOKENS, {
                token: response.data.access_token,
                tokenExp: Date.now() + response.data.expires_in * 1000,
                refreshToken: response.data.refresh_token
            })
        } catch (error) {
            return false
        }

        return true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
